import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import { DBIntFieldObjective, DBDropDown, DBTextArea, ToolTipBulb } from '_components';
import styles from './MaterialHandling.module.css';
import { noteActions } from '_actions';

class PatientCareCenterNoteObjectiveMaterialHandling extends React.Component {

    renderToolTip() {
        return (
            <div className={styles.tooltip}>
            <ToolTipBulb uid={'Material_Handling'} position='left' width={680} size='small'>
            <div className={styles.tooltipContainer}>
  <div className={styles.tooltipGrid}>
  <div className={`${styles.tooltipRow} ${styles.headerRow}`}>
          <div className={`${styles.tooltipCell} ${styles.emptyCell}`}></div>
          <div className={`${styles.tooltipCell} ${styles.headerSpan}`}>Duration of lifting or carrying</div>
        </div>

        <div className={styles.tooltipRow}>
          <div className={`${styles.tooltipCell} ${styles.headerCell}`}>Strength level</div>
          <div className={`${styles.tooltipCell} ${styles.headerCell}`}>Seldom</div>
          <div className={`${styles.tooltipCell} ${styles.headerCell}`}>Occasionally</div>
          <div className={`${styles.tooltipCell} ${styles.headerCell}`}>Frequently</div>
          <div className={`${styles.tooltipCell} ${styles.headerCell}`}>Constantly</div>
        </div>

    {[
      ["Sedentary work", "Up to 10 pounds", "Up to 10 pounds", "Negligible weight", "No weight"],
      ["Light work", "11–25 pounds", "11–25 pounds", "1–10 pounds", "Negligible weight"],
      ["Medium work", "26–50 pounds", "26–50 pounds", "11–25 pounds", "1–10 pounds"],
      ["Heavy work", "51–100 pounds", "51–100 pounds", "26–50 pounds", "11–25 pounds"],
      ["Very heavy work", ">100 pounds", ">100 pounds", ">50 pounds", ">25 pounds"],
    ].map((row, idx) => (
        <div className={styles.tooltipRow} key={idx}>
        {row.map((cell, i) => (
       <div className={styles.tooltipCell} key={i}>{cell}</div>
        ))}
      </div>
    ))}
  </div>
</div>
            </ToolTipBulb>
            </div>
        );
    }

    render() {
        let options = [
            { id: 'Occasional', value: 'Occasional' },
            { id: 'Frequent', value: 'Frequent' },
            { id: 'Constant', value: 'Constant' },
            { id: 'N/A', value: 'N/A' },
            { id: 'N/T', value: 'N/T' }
        ];
        return (
            <PatientCareCenterNoteSection id='obj_materialHandling' name='Material Handling' refProp={this.props.refProp} level={5} showToolTip toolTip={this.renderToolTip}>
                <div className={styles.row}>
                    <label className={styles.col1}><strong>Client can lift:</strong></label>
                    <label className={styles.col2}><strong>Job Requirement</strong></label>
                    <label className={styles.col3}><strong>Today's Measurements</strong></label>
                </div>
                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label className={this.props.jobLbs && this.props.jobTxt && this.props.curLbs && this.props.curTxt ? '' :styles.label_req}>Floor to waist</label>
                    </div>
                   
                    <div className={styles.col2_row}>

                    <DBIntFieldObjective
                     noteId={this.props.noteId}
                     entity='PTOBJECTIVEMATHAND'
                     entityKeyColumn='MHNO'
                     entityKeyValue={this.props.mhno}
                     field='MHFLTOWAJOBLBS'
                     className={styles.field}
                     min={0}
                    />
                    <label className={styles.label}>lbs.</label>
                        <DBDropDown
                        className={styles.drop_down}
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEMATHAND'
                        entityKeyColumn='MHNO'
                        entityKeyValue={this.props.mhno}
                        field='MHFLTOWAJOBTXT'
                        customOptions={options}
                    />
                    </div>
                    
                    <div className={styles.col3_row}>
                        <DBIntFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEMATHAND'
                        entityKeyColumn='MHNO'
                        entityKeyValue={this.props.mhno}
                        field='MHFLTOWACURLBS'
                        className={styles.field}
                        min={0}
                        />
                        
                    <label className={styles.label}>lbs.</label>
                    <DBDropDown
                        className={styles.drop_down}
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEMATHAND'
                        entityKeyColumn='MHNO'
                        entityKeyValue={this.props.mhno}
                        field='MHFLTOWACURTXT'
                        customOptions={options}
                    />
                    </div>
                </div>

                <div className={styles.row}>
                <div className={styles.col1_row}>
                        <label className={this.props.shoulderJobLbs && this.props.shoulderJobTxt && this.props.shoulderCurLbs && this.props.shoulderCurTxt ? '' :styles.label_req}>Waist to shoulder</label>
                </div>

                    <div className={styles.col2_row}>

                    <DBIntFieldObjective
                     noteId={this.props.noteId}
                     entity='PTOBJECTIVEMATHAND'
                     entityKeyColumn='MHNO'
                     entityKeyValue={this.props.mhno}
                     field='MHWATOSHJOBLBS'
                     className={styles.field}
                     min={0}
                    />
                    <label className={styles.label}>lbs.</label>
                        <DBDropDown
                        className={styles.drop_down}
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEMATHAND'
                        entityKeyColumn='MHNO'
                        entityKeyValue={this.props.mhno}
                        field='MHWATOSHJOBTXT'
                        customOptions={options}
                    />
                    </div>
                    
                    <div className={styles.col3_row}>
                    <DBIntFieldObjective
                     noteId={this.props.noteId}
                     entity='PTOBJECTIVEMATHAND'
                     entityKeyColumn='MHNO'
                     entityKeyValue={this.props.mhno}
                     field='MHWATOSHCURLBS'
                     className={styles.field}
                     min={0}
                    />
                    
                    <label className={styles.label}>lbs.</label>
                    <DBDropDown
                        className={styles.drop_down}
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEMATHAND'
                        entityKeyColumn='MHNO'
                        entityKeyValue={this.props.mhno}
                        field='MHWATOSHCURTXT'
                        customOptions={options}
                    />
                    </div>
                </div>

                <div className={styles.row}>
                <div className={styles.col1_row}>
                        <label className={this.props.overheadJobLbs && this.props.overheadJobTxt && this.props.overheadCurLbs && this.props.overheadCurTxt ? '' :styles.label_req}>Overhead</label>
                </div>
                  
                    <div className={styles.col2_row}>

                    <DBIntFieldObjective
                     noteId={this.props.noteId}
                     entity='PTOBJECTIVEMATHAND'
                     entityKeyColumn='MHNO'
                     entityKeyValue={this.props.mhno}
                     field='MHOVERJOBLBS'
                     className={styles.field}
                     min={0}
                    />
                    <label className={styles.label}>lbs.</label>
                        <DBDropDown
                        className={styles.drop_down}
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEMATHAND'
                        entityKeyColumn='MHNO'
                        entityKeyValue={this.props.mhno}
                        field='MHOVERJOBTXT'
                        customOptions={options}
                    />
                    </div>
                    
                    <div className={styles.col3_row}>
                    <DBIntFieldObjective
                     noteId={this.props.noteId}
                     entity='PTOBJECTIVEMATHAND'
                     entityKeyColumn='MHNO'
                     entityKeyValue={this.props.mhno}
                     field='MHOVERCURLBS'
                     className={styles.field}
                     min={0}
                    />
                    
                    <label className={styles.label}>lbs.</label>
                    <DBDropDown
                        className={styles.drop_down}
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEMATHAND'
                        entityKeyColumn='MHNO'
                        entityKeyValue={this.props.mhno}
                        field='MHOVERCURTXT'
                        customOptions={options}
                    />
                    </div>
                </div>

                <div className={styles.row}>
                <div className={styles.col1_row}>
                        <label className={this.props.carryJobLbs && this.props.carryJobTxt && this.props.carryCurLbs && this.props.carryCurTxt ? '' :styles.label_req}>Carry 50 ft.</label>
                </div>
                   
                    <div className={styles.col2_row}>

                    <DBIntFieldObjective
                     noteId={this.props.noteId}
                     entity='PTOBJECTIVEMATHAND'
                     entityKeyColumn='MHNO'
                     entityKeyValue={this.props.mhno}
                     field='MHCARRYJOBLBS'
                     className={styles.field}
                     min={0}
                    />
                    <label className={styles.label}>lbs.</label>
                        <DBDropDown
                        className={styles.drop_down}
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEMATHAND'
                        entityKeyColumn='MHNO'
                        entityKeyValue={this.props.mhno}
                        field='MHCARRYJOBTXT'
                        customOptions={options}
                    />
                    </div>
                    
                    <div className={styles.col3_row}>
                    <DBIntFieldObjective
                     noteId={this.props.noteId}
                     entity='PTOBJECTIVEMATHAND'
                     entityKeyColumn='MHNO'
                     entityKeyValue={this.props.mhno}
                     field='MHCARRYCURLBS'
                     className={styles.field}
                     min={0}
                    />
                    
                    <label className={styles.label}>lbs.</label>
                    <DBDropDown
                        className={styles.drop_down}
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEMATHAND'
                        entityKeyColumn='MHNO'
                        entityKeyValue={this.props.mhno}
                        field='MHCARRYCURTXT'
                        customOptions={options}
                    />
                    </div>
                </div>

                <div className={styles.row}>
               
                    <div className={styles.col1_row}>
                        <label>Push</label>
                    </div>
                    <div className={styles.col2_row}>

                    <DBIntFieldObjective
                     noteId={this.props.noteId}
                     entity='PTOBJECTIVEMATHAND'
                     entityKeyColumn='MHNO'
                     entityKeyValue={this.props.mhno}
                     field='MHPUSHJOBLBS'
                     className={styles.field}
                     min={0}
                    />
                    <label className={styles.label}>lbs.</label>
                        <DBDropDown
                        className={styles.drop_down}
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEMATHAND'
                        entityKeyColumn='MHNO'
                        entityKeyValue={this.props.mhno}
                        field='MHPUSHJOBTXT'
                        customOptions={options}
                    />
                    </div>
                    
                    <div className={styles.col3_row}>
                    <DBIntFieldObjective
                     noteId={this.props.noteId}
                     entity='PTOBJECTIVEMATHAND'
                     entityKeyColumn='MHNO'
                     entityKeyValue={this.props.mhno}
                     field='MHPUSHCURLBS'
                     className={styles.field}
                     min={0}
                    />
                    
                    <label className={styles.label}>lbs.</label>
                    <DBDropDown
                        className={styles.drop_down}
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEMATHAND'
                        entityKeyColumn='MHNO'
                        entityKeyValue={this.props.mhno}
                        field='MHPUSHCURTXT'
                        customOptions={options}
                    />
                    </div>
                </div>

                <div className={styles.row}>
                <div className={styles.col1_row}>
                        <label>Pull</label>
                    </div>
                    <div className={styles.col2_row}>

                    <DBIntFieldObjective
                     noteId={this.props.noteId}
                     entity='PTOBJECTIVEMATHAND'
                     entityKeyColumn='MHNO'
                     entityKeyValue={this.props.mhno}
                     field='MHPULLJOBLBS'
                     className={styles.field}
                     min={0}
                    />
                    <label className={styles.label}>lbs.</label>
                        <DBDropDown
                        className={styles.drop_down}
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEMATHAND'
                        entityKeyColumn='MHNO'
                        entityKeyValue={this.props.mhno}
                        field='MHPULLJOBTXT'
                        customOptions={options}
                    />
                    </div>
                    
                    <div className={styles.col3_row}>
                    <DBIntFieldObjective
                     noteId={this.props.noteId}
                     entity='PTOBJECTIVEMATHAND'
                     entityKeyColumn='MHNO'
                     entityKeyValue={this.props.mhno}
                     field='MHPULLCURLBS'
                     className={styles.field}
                     min={0}
                    />
                    
                    <label className={styles.label}>lbs.</label>
                    <DBDropDown
                        className={styles.drop_down}
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEMATHAND'
                        entityKeyColumn='MHNO'
                        entityKeyValue={this.props.mhno}
                        field='MHPULLCURTXT'
                        customOptions={options}
                    />
                    </div>
                </div>

                <div className={styles.row}>
                <div className={styles.col1_row}>
                        <label><strong>Comments</strong></label>
                    </div>
                </div>
              
               
                <DBTextArea
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVEMATHAND'
                    entityKeyColumn='MHNO'
                    entityKeyValue={this.props.mhno}
                    field='MHCOMMENTS'
                    className={styles.textarea}
                />
                   
                
            </PatientCareCenterNoteSection>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateTextField: bindActionCreators(noteActions.updateTextField, dispatch),
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let mhno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEMATHAND)
        .find(key => (state.entities.notes.PTOBJECTIVEMATHAND[key].MHEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEMATHAND[key].MHNTNO === pk && noteType !== 1)));

    return {
        noteId,
        mhno,
        jobLbs: state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHFLTOWAJOBLBS'] !== undefined
        && state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHFLTOWAJOBLBS'] !== null,
        jobTxt: state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHFLTOWAJOBTXT'] !== undefined
        && state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHFLTOWAJOBTXT'] !== null,
        curLbs: state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHFLTOWACURLBS'] !== undefined
        && state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHFLTOWACURLBS'] !== null,
        curTxt: state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHFLTOWACURTXT'] !== undefined
        && state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHFLTOWACURTXT'] !== null,

        shoulderJobLbs: state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHWATOSHJOBLBS'] !== undefined
        && state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHWATOSHJOBLBS'] !== null,
        shoulderJobTxt: state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHWATOSHJOBTXT'] !== undefined
        && state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHWATOSHJOBTXT'] !== null,
        shoulderCurLbs: state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHWATOSHCURLBS'] !== undefined
        && state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHWATOSHCURLBS'] !== null,
        shoulderCurTxt: state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHWATOSHCURTXT'] !== undefined
        && state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHWATOSHCURTXT'] !== null,

        overheadJobLbs: state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHOVERJOBLBS'] !== undefined
        && state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHOVERJOBLBS'] !== null,
        overheadJobTxt: state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHOVERJOBTXT'] !== undefined
        && state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHOVERJOBTXT'] !== null,
        overheadCurLbs: state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHOVERCURLBS'] !== undefined
        && state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHOVERCURLBS'] !== null,
        overheadCurTxt: state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHOVERCURTXT'] !== undefined
        && state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHOVERCURTXT'] !== null,

        carryJobLbs: state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHCARRYJOBLBS'] !== undefined
        && state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHCARRYJOBLBS'] !== null,
        carryJobTxt: state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHCARRYJOBTXT'] !== undefined
        && state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHCARRYJOBTXT'] !== null,
        carryCurLbs: state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHCARRYCURLBS'] !== undefined
        && state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHCARRYCURLBS'] !== null,
        carryCurTxt: state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHCARRYCURTXT'] !== undefined
        && state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHCARRYCURTXT'] !== null,

    };
}

const connectedPatientCareCenterNoteObjectiveMaterialHandling= connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteObjectiveMaterialHandling);
export { connectedPatientCareCenterNoteObjectiveMaterialHandling as PatientCareCenterNoteObjectiveMaterialHandling };

